
import AdminProfilePanel from "../components/superadmin/AdminProfile";

export default function SuperProfile() {
  return (
    <div>
      <AdminProfilePanel />
    </div>
  );
}
